import { useBookingEngineStateContext, usePropertyContext } from "@app/app/hooks";
import { Card, CardContent } from "@app/componentLibrary/ui/card";
import { Flex } from "@app/componentLibrary/ui/flex";
import { ThemeTitle } from "@app/componentLibrary/ui/text";
import { CheckIcon } from "@heroicons/react/24/outline";
import { StarIcon } from "@heroicons/react/24/solid";
import { eachDayOfInterval, isWeekend, parseISO } from "date-fns";
import { Fragment } from "react";

interface IReviewComponentProps {
    propertyName: string;
}

export const ReviewComponent = ({ propertyName }: IReviewComponentProps) => {
    const { activeProperty } = usePropertyContext();
    const { reviews } = useBookingEngineStateContext();
    const { getState } = useBookingEngineStateContext();
    const convertConfiguration = activeProperty?.convert_configuration;
    const minimumScore = convertConfiguration ? convertConfiguration.review_snapshot_min_score : 100;
    const showReviews = convertConfiguration?.is_review_snapshot_enabled && !!reviews && reviews.average_score >= minimumScore;
    let showUsp = false;
    let uspData = [] as string[];
    const language = getState("language");
    const bookings = getState("bookingState.bookings") || [];
    const oneRoomBooking = bookings.length === 1;
    const dates = getState("bookingState.dates");
    const hasChilds = !!bookings.reduce((sum, booking) => sum + Object.values(booking.childCount).reduce((acc, curr) => acc + curr, 0), 0);
    const adultCount = bookings.reduce((acc, booking) => acc + booking.adultsCount, 0);
    const dateRange =
        dates?.fromDate && dates?.toDate && eachDayOfInterval({ start: parseISO(dates.fromDate), end: parseISO(dates.toDate) });
    const countWeekendDays = (dateRange || []).reduce((acc, date) => (isWeekend(date) ? acc + 1 : acc), 0);
    const familyUsp = convertConfiguration?.personalized_usps_families?.[language] || [];
    const businessUsp = convertConfiguration?.personalized_usps_business?.[language] || [];
    const couplesUsp = convertConfiguration?.personalized_usps_couples?.[language] || [];

    console.log(
        "hiero1.4.1.5 - ReviewComponent - reviews",
        reviews,
        "minimumScore",
        minimumScore,
        "showReviews",
        showReviews,
        "convertConfiguration",
        convertConfiguration
    );

    if (convertConfiguration?.is_personalized_usps_families_enabled && familyUsp.length > 0 && hasChilds) {
        showUsp = true;
        uspData = familyUsp;
    } else if (
        convertConfiguration?.is_personalized_usps_couples_enabled &&
        couplesUsp.length > 0 &&
        oneRoomBooking &&
        !hasChilds &&
        adultCount > 1
    ) {
        showUsp = true;
        uspData = couplesUsp;
    } else if (
        convertConfiguration?.is_personalized_usps_business_enabled &&
        adultCount === 1 &&
        !hasChilds &&
        oneRoomBooking &&
        countWeekendDays === 0
    ) {
        showUsp = true;
        uspData = businessUsp;
    }

    return showReviews || showUsp ? (
        <Card className="mb-8 bg-[#FBFBFB]">
            <CardContent>
                <ThemeTitle size="base" className="mb-2 font-bold">
                    {propertyName}
                </ThemeTitle>
                {showReviews && (
                    <Flex className="text-sm text-gray-600 font-medium" justifyContent="start">
                        <StarIcon className="text-yellow-200 mr-1.5" width={16} />
                        {reviews?.average_score} ({reviews?.reviews_based_on.toLocaleString()} Reviews)
                    </Flex>
                )}

                {showReviews && showUsp && <div className="border-t my-3" />}

                {showUsp && (
                    <Fragment>
                        {/* <Text className="text-gray-500 text-sm mb-2 font-normal">Why couples appreciate our services:</Text> */}

                        <Flex justifyContent="start" flexDirection="col" className="gap-y-2">
                            {uspData.map((review, index) => (
                                <Flex key={index} className="text-primary text-sm" justifyContent="start" alignItems="start">
                                    <CheckIcon width={16} className="mr-1 mt-0.5" /> {review}
                                </Flex>
                            ))}
                        </Flex>
                    </Fragment>
                )}
            </CardContent>
        </Card>
    ) : null;
};
